<div id="vtz-main-wrapper" class="vtz-main-wrapper">
  <div id="vtz-main-container" class="vtz-main-container vtz-main-container--home">
    <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main class="vtz-review-container">
      <h1 class="vtz-h1" id="main-title" i18n>Scan a Voatz QR Code</h1>
      <div class="qr-code-main-container">
        <div #qrCodeReader id="qr-reader" class="qr-reader-element"></div>
      </div>
      @if (cameraHasError ) {
        @if (cameraError() === 'permission-denied') {
          <div class="camera-error-help">
            <h2 i18n style="text-align: center;">Camera Permission Denied</h2>
            <p i18n>In your favorite search engine you can search for the following: </p>
            <p i18n> <strong>Google Chrome: </strong> How to enable camera permissions for Google Chrome</p>
            <p i18n><strong>Safari: </strong> How to enable camera permissions for Safari</p>
            <p i18n><strong>Microsoft Edge </strong> How to enable camera permissions for Microsoft Edge</p>
            <p i18n><strong>Firefox: </strong> How to enable camera permissions for Firefox</p>
            <p i18n>Once you have solved the problem, click <strong> RETRY</strong> or <strong>BACK</strong> to return to the Dashboard.</p>
            <p i18n>⚠️  Do not reload this page.</p>
          </div>
        }

        @if (cameraError() === 'no-camera') {
          <div class="camera-error-help">
            <h2 style="color: #d9534f; text-align: center;" i18n>Camera Not Found</h2>
            <p i18n>The camera could not be accessed. This may be due to one of the following reasons:</p>

            <ol>
              <li i18n><strong>No camera is connected to the device:</strong> Ensure that your device has a built-in camera or that an external camera is properly connected.</li>

              <li i18n><strong>The camera is disabled at the operating system level:</strong>
                <ul>
                  <li><strong>Windows:</strong> Check <em>Settings > Privacy > Camera</em> and ensure camera access is enabled for apps and browsers.</li>
                  <li><strong>macOS:</strong> Check <em>System Preferences > Security & Privacy > Camera</em> and ensure your browser has permission to access the camera.</li>
                  <li><strong>Linux:</strong> Verify that the camera device is recognized (e.g., using <code>lsusb</code> or <code>v4l2</code> commands) and permissions are set correctly.
                  </li>
                </ul>
              </li>

              <li i18n><strong>The camera is in use by another application:</strong> Close any applications (e.g., Zoom, Teams, Skype) that might be using the camera and try again.</li>

              <li i18n><strong>Camera drivers are not installed or are corrupted:</strong> Reinstall or update the camera drivers on your system to ensure the device is recognized.</li>

              <li i18n><strong>Browser restrictions:</strong> Some browsers may block access to the camera due to security
                policies. Ensure that your site is served over HTTPS and check your browser settings for any blocked
                permissions.</li>
            </ol>
            <p style="font-weight: bold; color: #d9534f; margin-top: 20px;" i18n>
              Note: The steps and behavior described above may vary depending on the version of your operating system or
              browser. For the most accurate guidance, refer to your system or browser's official documentation.
            </p>
            <p i18n>Once you have solved the problem, click <strong> RETRY</strong> or <strong>BACK</strong> to return to the Dashboard.</p>

            <p i18n>If the problem persists, please try restarting your device or testing with another camera.</p>
            <p i18n>⚠️  Do not reload this page.</p>

          </div>
        }

        @if (cameraError() === 'generic') {
          <p class="error-text" i18n>An unexpected error occurred while accessing the camera.</p>
        }

      }

      <div class="dialog-button-container">
        <button id="go-to-previous" class="button-primary" (click)="previous()" i18n="Button label">
          BACK
        </button>
        @if (cameraHasError ) {
          <button class="button-primary" (click)="retryScanner()" i18n="Button label">
            RETRY
          </button>
        }
      </div>

      @if (displaySpinner) {
        <div class="progressSpinner">
          <mat-spinner [diameter]="300" color="primary"></mat-spinner>
          <div class="spinner-warning">
            <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
          </div>
        </div>  
      }
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>